import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../components/buttons/button';
import { ACCEPTED_COOKIES_KEY, CookieDAO } from '../../logic/cookies/cookie-dao';
import { FormattedMessage } from 'react-intl';

const CookieBarContainer = styled.div`
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 40px;
  background-color var(--matt-lighter-bg-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CookieBar = (): JSX.Element | null => {
  const [isShowing, setIsShowing] = useState<boolean>(!CookieDAO.get(ACCEPTED_COOKIES_KEY));

  const handleAcceptCookies = (): void => {
    CookieDAO.set(ACCEPTED_COOKIES_KEY, true);
    setIsShowing(false);
  };

  const handleLinkClick = (): void => {
    window.open('https://ertektar.hu/adatvedelmi-tajekoztato-a-weboldalhoz/', '_blank');
  };

  if (!isShowing) {
    return null;
  }

  return (
    <CookieBarContainer className="flex-col sm:flex-row">
      <p className="text-14 mb-3 sm:mb-0">
        <FormattedMessage id="cookieConsent.messagePartFirst" />
        <span onClick={handleLinkClick} className="cursor-pointer underline">
          <b>
            <FormattedMessage id="cookieConsent.messagePrivacyPolicy" />
          </b>
        </span>
        <FormattedMessage id="cookieConsent.messagePartLast" />
      </p>
      <Button onClick={handleAcceptCookies} className="ml-2">
        <FormattedMessage id="cookieConsent.acceptButton" />
      </Button>
    </CookieBarContainer>
  );
};

export default CookieBar;
